import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navigation from "../components/navigation";
import { loginMarketplace } from "../api/marketplaceAuth";
export default function SellerLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  async function submit(event) {
    event.preventDefault();
    setError("");
    setSaving(true);
    try {
      const result = await loginMarketplace(email, password);
      navigate(result.user.role === "seller" ? "/seller-portal" : "/");
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  }
  return (
    <main className="">
      <Navigation />
      <section className="mx-auto max-w-md px-6 py-20">
        <div className="rounded-2xl border border-border bg-white p-8 shadow-sm">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#c1392a]">
            Marketplace account
          </p>
          <h1 className="mt-3 font-heading text-3xl font-bold text-dark">
            Welcome back
          </h1>
          <p className="mt-2 text-sm text-muted">
            Sign in to manage your seller listings.
          </p>
          <form onSubmit={submit} className="mt-7 grid gap-4">
            <label className="grid gap-2 text-sm font-semibold text-dark">
              Email
              <input
                required
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="rounded-lg border border-border px-4 py-3 font-normal"
              />
            </label>
            <label className="grid gap-2 text-sm font-semibold text-dark">
              Password
              <input
                required
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="rounded-lg border border-border px-4 py-3 font-normal"
              />
            </label>
            {error && (
              <p
                role="alert"
                className="rounded-lg bg-red-50 p-3 text-sm text-red-700"
              >
                {error}
              </p>
            )}
            <button
              disabled={saving}
              className="rounded-lg bg-[#c1392a] px-5 py-3 font-semibold text-white"
            >
              {saving ? "Signing in..." : "Sign in"}
            </button>
          </form>
          <p className="mt-6 text-center text-sm text-muted">
            New here?{" "}
            <Link to="/signup" className="font-semibold text-[#c1392a]">
              Create an account
            </Link>
          </p>
        </div>
      </section>
    </main>
  );
}
